import {
  APIBlobResponse,
  PaginatedAPIResponse,
} from "../models/NetworkResponse";
import { WaitlistEntry } from "../models/Swayy/Waitlist";
import { WaitlistFilters } from "../models/Swayy/WaitlistFilters";
import { downloadFile, getAPI } from "./Networking";

export default class SwayyWaitlistAPI {
  getQueryParams = (filters: WaitlistFilters): URLSearchParams => {
    const queryParams = new URLSearchParams();
    if (filters.page_no) {
      queryParams.append("page_no", filters.page_no.toString());
    }
    if (filters.limit) {
      queryParams.append("limit", filters.limit.toString());
    }
    if (filters.sort_by) {
      queryParams.append("sort_by", filters.sort_by);
    }
    if (filters.sort_type) {
      queryParams.append("sort_type", filters.sort_type);
    }
    return queryParams;
  };

  getWaitlist = async (
    filters: WaitlistFilters,
  ): Promise<PaginatedAPIResponse<WaitlistEntry>> => {
    const queryParams = this.getQueryParams(filters);
    const response = await getAPI(`/v1/swayy-waitlist?${queryParams.toString()}`);
    return response.result;
  };

  downloadWaitlist = async (): Promise<APIBlobResponse> => {
    return downloadFile("/v1/swayy-waitlist/download");
  };
}
